import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { FormField, FormSelect, Label, LabelGroup } from 'semantic-ui-react'
import { observer } from 'mobx-react'
import FormEntry from '../../../models/FormEntry'

@observer
class SelectMultiple extends Component {
  static propTypes = {
    ...FormSelect.propTypes,
    options: FormSelect.propTypes.options,
    formEntry: PropTypes.instanceOf(FormEntry).isRequired,
    label: PropTypes.string,
    defaultValue: PropTypes.any,
    errorPointing: PropTypes.oneOf(['below', 'above', 'left']),
    castValue: PropTypes.func, // could be useful if you want to cast a value entered
    parseValue: PropTypes.func, // could be useful if you want to parse value to form value
    onAfterChanged: PropTypes.func
  }

  static defaultProps = {
    errorPointing: 'above',
    isFixed: false
  }

  handleOnChangeInput = (e, data) => {
    const { formEntry, onAfterChanged, options } = this.props
    const selected = options.map(({ value }) => formEntry.getValue(value)).filter(value => value !== '')
    const toAdd = data.value.filter(value => !selected.includes(value))
    const toRemove = selected.filter(value => !data.value.includes(value))
    for (const key of toAdd) {
      formEntry.updateValue(key, key)
    }
    for (const key of toRemove) {
      formEntry.updateValue(key, '')
    }
    this.setState({ selected: data.value })
    if (onAfterChanged) {
      onAfterChanged()
    }
  }

  render () {
    const {
      formEntry,
      defaultValue,
      options,
      onChange,
      castValue,
      parseValue,
      errorPointing,
      error,
      onAfterChanged,
      isFixed,
      ...props
    } = this.props
    const selected = options.map(({ value }) => formEntry.getValue(value)).filter(value => value !== '')
    if (formEntry.readonly) {
      return (
        <FormField>
          <label>{this.props.label}</label>
          <LabelGroup>
            {options
              .filter(option => selected.includes(option.value))
              .map(option => (<Label key={`sm_${option.value}`}>{option.text}</Label>))}
          </LabelGroup>
        </FormField>
      )
    }
    return (
      <FormSelect
        multiple
        options={options}
        value={selected}
        onChange={onChange || this.handleOnChangeInput}
        readOnly={formEntry.readonly}
        {...props}
      />
    )
  }
}
export default SelectMultiple
